import React, { memo } from "react";

interface SubscriptionHeaderProps {
  title: string;
  desc?: string;
}

const SubscriptionHeader: React.FC<SubscriptionHeaderProps> = ({
  title,
  desc,
}) => {
  return (
    <div className="hidden md:flex justify-center items-center flex-col w-full gap-1 mt-5">
      <h1
        aria-label="index h1"
        data-openreplay-label="member_index_h1"
        id="sem-index-h1"
        className="text-content_primary display_s"
      >
        {title}
      </h1>
      {desc && <p className="text-content_primary body_medium_l">{desc}</p>}
    </div>
  );
};

export default memo(SubscriptionHeader);
